module.exports = __webpack_public_path__ + "static/media/suggestedToFriends_25_50.42239116.png";